import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para todos los años de la secundaria?',
    a: 'Sí. Cada tomo tiene adaptaciones para ciclo básico (1° a 3°) y ciclo orientado (4° a 6°). La Guía Rápida te indica exactamente cómo adaptar cada módulo según el año que tengas.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Al completar el pago recibís un link de descarga inmediata con todos los PDFs. En menos de 5 minutos tenés todo disponible para imprimir o usar en pantalla.'
  }, {
    q: '¿Qué lo diferencia del material que encuentro online?',
    a: 'Todo lo que encontrás online está pensado para Buenos Aires o para el aula urbana. Este kit está diseñado específicamente para escuelas secundarias rurales y técnicas, con ejemplos del contexto argentino y rural, articulación con la Orientación Agro y Ambiente y adaptaciones para grupos heterogéneos y pluricurso.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no es lo que esperabas, escribís a un mail y te devolvemos el 100% sin preguntas. Más del 99% de quienes lo compraron no necesitaron usarla.'
  }, {
    q: '¿Funciona para una escuela con pluricurso?',
    a: 'Sí. La Guía Rápida incluye una sección específica de adaptaciones para pluricurso con estrategias concretas para trabajar con distintos años en el mismo espacio.'
  }, {
    q: '¿Puedo imprimir los materiales para mis alumnos?',
    a: '¡Totalmente! Todos los PDFs están optimizados para impresión en blanco y negro o color. Las actividades y evaluaciones están diseñadas específicamente para ser fotocopiadas y repartidas en el aula.'
  }, {
    q: '¿El material está actualizado a los diseños curriculares vigentes?',
    a: 'Sí, los contenidos están alineados con los Núcleos de Aprendizajes Prioritarios (NAP) nacionales y cubren los ejes principales de los diseños curriculares provinciales para el área de Ciencias Sociales y la Orientación Agro y Ambiente.'
  }, {
    q: '¿Necesito internet en el aula para usarlo?',
    a: 'No. Una vez que descargás los PDFs en tu computadora o pendrive, podés usarlos offline, imprimirlos o proyectarlos sin necesidad de conexión a internet, ideal para escuelas rurales con poca conectividad.'
  }, {
    q: '¿Sirve si doy Geografía o Formación Ética?',
    a: 'Sí, especialmente la versión con Casos Reales. Muchos de los conflictos agrarios, la distribución territorial y los debates ambientales son perfectos para articular Historia con Geografía y Ciudadanía.'
  }, {
    q: '¿Hay que pagar alguna mensualidad?',
    a: 'No. Es un pago único. Comprás el kit hoy y te queda para siempre, sin suscripciones ni cobros ocultos.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-78">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3" data-id="element-79">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-dark rounded-lg border ${openIndex === index ? 'border-brand-accent/50' : 'border-white/10'} overflow-hidden transition-all duration-200`} data-id="element-80">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-81">
                <span className={`font-bold text-sm md:text-base pr-4 ${openIndex === index ? 'text-brand-accent' : 'text-gray-200'}`} data-id="element-82">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-83" /> : <ChevronDown className="w-5 h-5 text-gray-600 shrink-0" data-id="element-84" />}
              </button>

              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-85">
                <p className="text-sm md:text-base text-gray-400 leading-relaxed pt-2 border-t border-white/5" data-id="element-86">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}